/**
 * Experiment/feature flag key registry.
 * All experiment and feature flag keys managed through the experimentation system.
 * Use these keys instead of literal strings everywhere.
 */
const ExperimentKey = Object.freeze({
    /** @deprecated Expired Jan 2025. Backend callers still reference this — clean up separately. */
    FreeTrainGpu: "free-train-gpu",
    /** Gradual rollout of the Continuous Improvement feature via PostHog. */
    ContinuousImprovementRollout: "continuous-improvement-rollout",
    /** A/B test: collapse the feature list in the trial welcome modal behind a toggle. */
    TrialModalCollapsibleFeatures: "trial-modal-collapsible-features"
});

module.exports = { ExperimentKey };
